import { LEGAL_DOCS } from '@/data/legal';
import { legalHash } from '@/lib/legalRoute';
import { openCookieSettings } from '@/components/CookieConsent';

/**
 * Reusable row of legal links + a «Настройки cookie» control (29 JUN 2026).
 * Dropped into the auth screens, Profile, and the global SiteFooter. The links
 * are real `<a href="#/...">` anchors so they open in a new tab and are
 * crawlable; LegalGate (App.tsx) renders the page above the auth gate.
 */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <nav className={`legal-links${className ? ` ${className}` : ''}`} aria-label="Правовая информация">
      {LEGAL_DOCS.map((d) => (
        <a key={d.id} className="legal-links__link" href={legalHash(d.id)}>
          {d.shortTitle}
        </a>
      ))}
      <button type="button" className="legal-links__cookiebtn" onClick={openCookieSettings}>
        Настройки cookie
      </button>
    </nav>
  );
}
